// Copyright © 2024 Ory Corp
// SPDX-License-Identifier: Apache-2.0

export function DefaultHorizontalDivider() {
  return <hr className="border-interface-border-default-primary" />
}
